module.exports = __webpack_public_path__ + "img/diente71.f0546e12.png";